import React from 'react'
import { H1, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import SubPersonPageDecoratorSkeleton from '../common/SubPersonPageDecoratorSkeleton'
import ResearchHelpContentSkeleton from './components/ResearchHelpContentSkeleton'

export default function DismissedHintsPageSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <SubPersonPageDecoratorSkeleton>
      <H1 size="H5">{t('research-help.dismissed-hints.label')}</H1>
      <Separator size="sm" />
      <ResearchHelpContentSkeleton showQualityScoreImprovements />
    </SubPersonPageDecoratorSkeleton>
  )
}
